
import React, { useState } from 'react';

import {
    Container,
    Header,
    ToggleMenu,
    MenuContainer,
    MenuItemLink,
    Menu,
    DashBoardIcon,
    HomeIcon,
    BiSupportIcon,
    AdminIcon,
    ExitIcon,
    MdAccessTimeIcon,
    MdChecklistIcon
} from './styles';

import {
    MdClose,
    MdMenu
} from 'react-icons/md';

import { Link } from 'react-router-dom';
import { useSidebar } from '../../hooks/useSidebar';

const Aside : React.FC = () => {

    const { sideBarStatus, setSideBarStatus } = useSidebar();

    const handleToggleMenu = () => {
        setSideBarStatus(!sideBarStatus);
    };

    return (
        <Container >
            <Header>
                    <ToggleMenu onClick={handleToggleMenu}>
                        { sideBarStatus ? <MdClose /> : <MdMenu /> }
                    </ToggleMenu>
            </Header>
            <Menu>
                <MenuContainer>
              
                    <Link to="/">
                        <MenuItemLink menuIsOpen={sideBarStatus} title='Home'>
                            <HomeIcon />
                            <p>Home</p>
                        </MenuItemLink>
                    </Link>

                    <Link to="/chamados">
                        <MenuItemLink menuIsOpen={sideBarStatus}  title='Chamados'>
                            <BiSupportIcon />
                            <p>Chamados</p>
                        </MenuItemLink>
                    </Link>

                    <Link to="/follow">
                        <MenuItemLink menuIsOpen={sideBarStatus}  title='follow'>
                            <MdAccessTimeIcon />
                            <p>Suporte</p>
                        </MenuItemLink>
                    </Link>

                    <Link to="/project">
                        <MenuItemLink menuIsOpen={sideBarStatus}  title='project'>
                            <MdChecklistIcon />
                            <p>Projeto</p>
                        </MenuItemLink>
                    </Link>
                </MenuContainer>


                <MenuContainer>
                    <Link to="/admin">
                        <MenuItemLink menuIsOpen={sideBarStatus} title='Admin'>
                            <AdminIcon />
                            <p>Admin</p>
                        </MenuItemLink>
                    </Link>

                    {/* <MenuItemLink menuIsOpen={sideBarStatus} onClick={() => {}}  title='Sair'>
                        <ExitIcon />
                        <p>Sair</p>
                    </MenuItemLink> */}
                </MenuContainer>
            </Menu>

        </Container>
    )
}

export default Aside;